import _extends from "@babel/runtime/helpers/extends";

/**
 * @module FieldControls
 */
import { InputLabel } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import MonacoEditor from 'react-monaco-editor';
import { changeTemplatedValue } from "../helpers.js";

/**
 * Field control that represents a LongText field. Available values will be populated from the FieldSettings.
 */
export const HtmlEditor = props => {
  var _props$theme;

  const initialState = props.fieldValue || props.actionName === 'new' && changeTemplatedValue(props.settings.DefaultValue) || '';
  const [value, setValue] = useState(initialState);
  const readonly = props.actionName === 'browse' || props.settings.ReadOnly;
  const editorRef = useRef(null);
  const containerRef = useRef(null);
  useEffect(() => {
    if (!editorRef.current) {
      return;
    }

    editorRef.current.editor.onDidContentSizeChange(() => {
      var _editorRef$current, _editorRef$current$ed;

      const contentHeight = editorRef === null || editorRef === void 0 ? void 0 : (_editorRef$current = editorRef.current) === null || _editorRef$current === void 0 ? void 0 : (_editorRef$current$ed = _editorRef$current.editor) === null || _editorRef$current$ed === void 0 ? void 0 : _editorRef$current$ed.getContentHeight();
      containerRef.current.style.height = `${contentHeight}px`;
    });
  }, [editorRef]);

  const editorChangeHandler = newValue => {
    var _props$fieldOnChange;

    setValue(newValue);
    (_props$fieldOnChange = props.fieldOnChange) === null || _props$fieldOnChange === void 0 ? void 0 : _props$fieldOnChange.call(props, props.settings.Name, newValue);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputLabel, {
    shrink: true
  }, props.settings.DisplayName), /*#__PURE__*/React.createElement("div", {
    style: {
      maxHeight: '68vh',
      margin: '0.5rem 0'
    },
    ref: containerRef,
    "data-test": "html-editor-container"
  }, /*#__PURE__*/React.createElement(MonacoEditor, _extends({
    ref: editorRef
  }, props, {
    width: "100%",
    height: "100%",
    value: value,
    onChange: editorChangeHandler,
    options: {
      automaticLayout: true,
      contextmenu: true,
      hideCursorInOverviewRuler: true,
      lineNumbers: 'on',
      selectOnLineNumbers: true,
      scrollBeyondLastLine: false,
      minimap: {
        enabled: true
      },
      roundedSelection: false,
      readOnly: readonly,
      cursorStyle: 'line',
      scrollbar: {
        horizontalSliderSize: 4,
        verticalScrollbarSize: 6 // vertical: 'hidden',

      },
      wordWrap: 'on',
      autoIndent: 'advanced',
      matchBrackets: 'always',
      language: 'html',
      suggest: {
        snippetsPreventQuickSuggestions: false,
        showProperties: true,
        showKeywords: true,
        showWords: true
      }
    },
    theme: ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.palette.type) === 'dark' ? 'admin-ui-dark' : 'vs-light',
    editorWillMount: monaco => {
      monaco.editor.defineTheme('admin-ui-dark', {
        base: 'vs-dark',
        inherit: true,
        rules: [],
        colors: {
          'editor.background': '#121212'
        }
      });
    }
  }))));
};
//# sourceMappingURL=html-editor.js.map